// extracted by mini-css-extract-plugin
export default {"gridSection":"GridView_gridSection__tS51G"};